<template>
  <div class="personCheck">
    <Modal
      title="绑定应用"
      v-model="modalView"
      @on-visible-change="changeVisible"
      :mask-closable="false"
      width="820"
      class="personCheck-modal"
    >
      <div class="personCheck-modal-search">
        <div>
          <Select v-model="selectValue" class="personCheck-modal-select">
            <Option
              v-for="(item, index) in selectList"
              :value="item.id"
              :key="index"
            >{{ item.value }}</Option>
          </Select>
          <Input
            placeholder="请输入应用名称或APPID"
            v-model="search.appIdOrApplicationName"
            class="personCheck-modal-input"
          ></Input>
          <Button
            type="primary"
            shape="circle"
            icon="ios-search"
            class="mr-16"
            @click="immediateUseList"
          >查询</Button>
          <Button shape="circle" @click="reset">
            <i class="icon tsit icon_shuaxin mr-4"></i>重置
          </Button>
        </div>
        <Button shape="circle" class="personCheck-normal-btn" @click="link('/manage/addapp')">新建应用</Button>
      </div>
      <Table
        @on-select="selectItem"
        @on-select-cancel="itemCancel"
        @on-select-all="selectAll"
        @on-select-all-cancel="allCancel"
        :columns="dataCol"
        :data="useList"
      >
        <template slot="status" slot-scope="{ row }">
          <p v-if="row.isBind == true">已绑定</p>
          <p v-if="row.isBind == false">未绑定</p>
        </template>
      </Table>
      <Row class="mt-16" type="flex" justify="center">
        <Page
          :total="total"
          :page-size="search.pageSize"
          :page-size-opts="psize"
          :current="search.pageIndex"
          @on-change="handlePage"
          @on-page-size-change="sizeChange"
          show-sizer
          show-total
          show-elevator
          placement="top"
        />
      </Row>
      <div slot="footer" class="personCheck-modal-footer">
        <Button
          type="primary"
          shape="circle"
          class="personCheck-modal-normalbtn"
          style="margin-right: 8px"
          @click="confirm"
        >确定</Button>
        <Button shape="circle" class="personCheck-modal-normalbtn" @click="cancle">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
// import { appList ,serviceBind} from "@/api/service";

export default {
  data() {
    return {
      total: 0,
      psize: [2, 6, 9],
      search: {
        pageIndex: 1,
        pageSize: 2
      },
      useList: [],
      modalView: false,
      selectValue: "",
      selectList: [
        {
          id: "0",
          value: "未绑定"
        },
        {
          id: "1",
          value: "已绑定"
        }
      ],
      dataCol: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "应用名称",
          key: "name"
        },
        {
          title: "APPID",
          key: "id"
        },
        {
          title: "状态",
          key: "status",
          slot: "status"
        }
      ],
      checkedList: [],
      checkedList_page: [],
      loading: false
    };
  },
  created() {
    this.modalView = true;
    this.search.serviceId = this.$route.query.id;
    this.immediateUseList();
  },
  watch: {
    //解决当前页最后一条删除后，没有自动折页的问题-因分页用的地方太多，混入监听
    total() {
      const cPage = this.total / this.search.pageSize;
      if (this.search.pageIndex === cPage + 1 && this.search.pageIndex != 1) {
        this.search.pageIndex = this.search.pageIndex - 1;
        this.immediateUseList(); //获取列表数据
      }
    }
  },
  methods: {
    //当前页的选中数据，切换页码时的选中状态无法保留
    checked() {},
    //选中数据
    selectItem(sel, row) {
      this.checkedList.push(row);
      //当前页数据
      this.checkedList_page = sel;
    },
    //选项取消
    itemCancel(sel, row) {
      this.checkedList = this.checkedList.filter(x => x.id != row.id);
      this.checkedList_page = sel;
    },
    selectAll(sel) {
      console.log(sel, "当前页全选--");
      this.checkedList_page = sel;
      sel.forEach(item => {
        //查找未选中的数据
        let t = this.checkedList.find(x => x.id == item.id);
        if (!t) {
          //未选中的数据插入
          this.checkedList.push(item);
        }
      });
    },
    //取消本页已选中
    allCancel(sel) {
      console.log(sel, this.checkedList_page, "当前页取消选中");
      let list = this.checkedList;
      this.checkedList.forEach((item, index) => {
        let t = this.checkedList_page.find(x => x.id == item.id);
        //如果是当前页的数据，删除
        if (t) {
          delete list[index];
        }
      });
      this.checkedList = list.filter(x => x);
      this.checkedList_page = [];
    },
    handlePage(value) {
      this.search.pageIndex = value;
      this.immediateUseList();
    },
    sizeChange(value) {
      this.search.pageSize = value;
      this.immediateUseList();
    },
    rowClick(row, index) {
      this.$refs.selection.toggleSelect(index);
    },
    reset() {
      let self = this;
      this.selectValue = "";
      this.search = {
        pageIndex: 1,
        pageSize: 2
      };
      self.immediateUseList();
    },
    immediateUseList() {
      //切换页码时重置当前页选中项
      this.checkedList_page = [];
      if (this.selectValue) {
        this.search.isBind = this.selectValue * 1 == 0 ? false : true;
      }
      appList(this.search).then(res => {
        if (res.data.code == 0) {
          console.log("服务绑定", res);
          let json = res.data.data;
          // json[0].bind = true;
          json.forEach(item => {
            if (item.isBind) {
              item._disabled = true;
            }
            let t = this.checkedList.find(x => x.id == item.id);
            if (t) {
              item._checked = true;
              this.checkedList_page.push(item);
            }
          });
          this.useList = json;
          this.total = res.data.page.totalCount;
        } else {
          console.log("请求数据失败");
        }
      });
    },
    link(path) {
      this.$router.push({ path: path });
    },
    confirm() {
      if (this.checkedList.length == 0) {
        this.$Message.error("请选择应用");
        return;
      }
      let list = this.checkedList.map(x => x.id);
      let data = {
        serviceId: this.search.serviceId,
        applicationIds: list
      };
      this.loading = true;
      serviceBind(data).then(res => {
        this.$Message.success("应用绑定成功");
        this.modalView = false;
        this.loading = false;
      });
    },
    cancle() {
      this.modalView = false;
    },
    changeVisible(val) {
      if (!val) {
        this.$emit("close");
      }
    }
  }
};
</script>

<style lang="scss">
.personCheck-modal {
  &-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  &-select {
    width: 112px;
    margin-right: 20px;
    .ivu-select-selection {
      height: 36px;
    }
    .ivu-select-selection .ivu-select-placeholder,
    .ivu-select-selection .ivu-select-selected-value {
      height: 36px;
      line-height: 36px;
    }
  }
  &-input {
    width: 300px;
    margin-right: 16px;
  }
  &-footer {
    text-align: right;
  }
  .ivu-modal-footer {
    border-top: unset;
  }
  &-normalbtn {
    width: 105px;
  }
}
</style>
